var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 240,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "#FCB519"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 106.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 187.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 268.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 349.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.5,
    cy: 113.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 106.5,
    cy: 113.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 187.5,
    cy: 113.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 268.5,
    cy: 113.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 349.5,
    cy: 113.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.5,
    cy: 194.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 106.5,
    cy: 194.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 187.5,
    cy: 194.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 268.5,
    cy: 194.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 349.5,
    cy: 194.5,
    r: 32.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.768 154.052c-1.279.024-2.636 1.649-3.154 2.459l-.557 4.49c.585-.118 2.366-.14 4.814.71 3.06 1.064 8.131 7.049 10.743 9.881 2.091 2.265 6.795 4.034 8.703 3.358l3.219-7.58c-.482-.097-2.584.432-5.29-.541-3.383-1.218-5.563-6.617-10.267-10.05-4.704-3.432-6.611-2.757-8.211-2.727Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.955 179.176c2.166-.552 3.986-3.647 4.232-4.719.389.847.462 4.184.104 5.599-1.186 4.692-2.156 4.52-3.894 5.672-1.739 1.152-6.522 2.041-10.183 3.069-3.661 1.028-10.645 4.038-15.062 7.48-3.532 2.754-7.924 6.921-9.433 8.976l-3.333-7.138c3.084-3.418 9.896-9.944 15.603-12.77 8.302-4.111 19.259-5.478 21.966-6.169Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.919 136.271c3.803-1.99 4.518-3.657 4.401-4.242.722 1.534 2.045 5.018 1.564 6.691-.601 2.092-3.755 4.55-6.448 6.04-2.692 1.49-12.06 5.344-15.846 8.295-3.028 2.36-3.344 3.689-3.124 4.058l-1.152-1.739c1.236-2.316 1.893-5.041 5.588-9.224 2.93-3.315 10.263-7.39 15.017-9.879Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.907 105.514c-3.017 3-4.269 5.626-4.357 6.641l.919 6.383c.205-.43.656-1.669 2.647-3.889 4.233-4.719 16.269-11.396 23.387-15.795l-3.874-1.848 1.51-4.828c-5.487 3.195-17.216 10.336-20.232 13.336Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.359 119.124c-1.832-2.142-4.073-3.924-3.08-8.999-1.694 3.552-3.149 9.595-2.305 11.979 1.335 3.77 5.901 7.571 7.714 10.417 1.45 2.277 2.334 5.077 1.733 7.168 1.247-1.783 2.45-7.63 2.514-11.087.08-4.321-4.287-6.8-6.576-9.478Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.842 160.186c-.294-2.042.669-4.172 1.188-4.982-1.842 1.368-5.709 4.49-6.448 6.04-.924 1.937-.021 7.52 1.514 12.612 1.228 4.073 1.061 8.3.824 9.905 1.868-2.808 5.623-9.129 5.698-11.946.095-3.522-2.408-9.076-2.776-11.629Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.819 158.866c-.691-2.707.82-7.535 2.206-10.441-2.34 3.244-5.619 7.625-6.513 11.161-1.24 4.905.178 9.597.223 11.996.036 1.92-.109 2.723-.417 3.368l2.983-.838c.447-.125.877-.326 1.195-.664 2.071-2.209 2.462-6.679 2.195-8.536-.367-2.554-1.182-3.338-1.872-6.046Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198 240 .58-99.92 58.48-20.16v97.966c0 .596-.178 1.178-.51 1.673l-.218.324a2.999 2.999 0 0 1-1.515 1.164L199.87 239.92 198 240Z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M257.06 150.64v-30.72l-58.48 20.16v32.64l58.48-22.08Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDE6B2",
    d: "M201.16 133.84h6.02v7.68h-6.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28 240v-99.56L114 127v93.596c0 .627.196 1.238.562 1.748l.466.651a3.003 3.003 0 0 0 1.857 1.195L196 240h2.28Z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M198.581 172.72v-32.64l-84.28-13.44v28.8l84.28 17.28Z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "m142.68 150.16 20.21 2.4v80.721l-20.21-3.921v-79.2Z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m202.02 135.56-88.49-14.064a3.001 3.001 0 0 0-2.892 1.192l-.059.081a3 3 0 0 0-.579 1.771v18.058a3 3 0 0 0 1.331 2.493l.301.202c.342.229.727.385 1.131.459l88.092 16.074a2.084 2.084 0 0 0 2.455-2.048V139.88l-1.29-4.32Z",
    fill: "url(#o)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "m225.24 142.48 17.2-5.76v88.32l-17.2 6.009V142.48Z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m204.601 135.08 56.933-20.094a2.45 2.45 0 0 1 3.267 2.311v20.895c0 .476-.129.944-.374 1.353a2.632 2.632 0 0 1-1.381 1.133l-58 20.643a1.299 1.299 0 0 1-1.735-1.224V140.36l1.29-5.28Z",
    fill: "url(#r)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m182.241 106 79.66 8.94-57.3 20.34-1.29.48h-1.29l-90.3-14.4 70.52-15.36Z",
    fill: "url(#t)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "m226.961 127.12 17.2-5.76v26.4l-17.2 6.009V127.12Z",
    fill: "#4E4D48"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "m140.961 126.16 19.78 2.88v25.92l-19.78-3.84v-24.96Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m140.961 126.16 64.5-17.28 20.21 2.4-64.93 17.76-19.78-2.88Z",
    fill: "#383631"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m244.16 121.359-86-10.079-15.05 3.36 83.85 12.479 17.2-5.76Z",
    fill: "#383631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.985 73.674c9.419 9.989 20.25 29.966 24.018 36.8.157 1.928.471 5.993.471 6.835 0 1.051-9.419-7.886-19.309-16.298-7.912-6.729-27.786-19.977-42.386-25.76l15.071-4.205V59.48c4.709 1.051 12.621 4.106 22.135 14.194Z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.383 73.674c-9.419 9.989-20.251 29.966-24.019 36.8-.157 1.928-.471 5.993-.471 6.835 0 1.051 9.419-7.886 19.309-16.298 7.912-6.729 27.786-19.977 42.386-25.76l-15.071-4.205V59.48c-4.709 1.051-12.621 4.106-22.134 14.194Z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.614 92.6c-7.064 4.206-19.309 19.977-20.251 21.029.314 3.154 1.036 9.673 1.413 10.514.471 1.051 14.6-1.052 26.373-4.206 11.774-3.154 17.897-7.886 18.368-12.617.471-4.731-2.355-3.68-7.065-7.886-1.353-1.209-2.383-5.747-2.913-9.442-.277-1.925-1.935-3.304-3.614-2.763-3.425 1.102-8.235 2.945-12.311 5.371Z",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9 104.054c-1.973-1.384-6.635.307-13.983 7.997-8.172 8.553-16.286 10.302-21.158 11.353-.342.074-.668.144-.977.213-.769.172-1.493.317-2.163.44 5.3-.665 13.353-2.197 20.53-4.12 11.179-2.995 17.263-7.412 18.253-11.9.071-.401.121-.792.15-1.163.079-1.349-.152-2.181-.652-2.82Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.964 93.03c7.182 3.95 19.874 19.275 20.846 20.292-.223 3.164-.757 9.705-1.11 10.559-.44 1.068-14.622-.527-26.48-3.258-11.859-2.73-18.114-7.24-18.721-11.952-.607-4.712 2.248-3.762 6.834-8.135 1.318-1.257 2.216-5.83 2.64-9.541.221-1.935 1.839-3.372 3.532-2.892 3.456.979 8.316 2.648 12.459 4.927Z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.021 105.385c1.933-1.454 6.64.068 14.206 7.492 8.414 8.255 16.574 9.713 21.473 10.588.344.061.672.12.983.178.774.144 1.502.263 2.175.362-5.317-.475-13.409-1.717-20.638-3.382-11.26-2.592-17.468-6.789-18.586-11.239a12.339 12.339 0 0 1-.184-1.157c-.118-1.346.089-2.185.571-2.842Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.062 109.423c.744-.831 2.825 0 6.593 0 1.884 0 5.18-2.103 7.064 0 0 0 .589.92.942 2.103.471 1.577.942 11.565.471 12.617-.471 1.051-1.858 1.577-6.122 1.577-5.652 0-8.478 0-9.891-1.577-1.598-1.785 0-13.669.943-14.72Z",
    fill: "url(#z)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.788 174.052c-.606-1.212-2.777-1.767-3.786-1.893l-4.543 1.514c.378.505 1.211 2.196 1.514 4.922.379 3.407-3.029 10.98-4.543 14.766-1.212 3.029-.758 8.329.757 9.844l8.708-.379c-.126-.505-1.59-2.272-1.893-5.301-.379-3.786 3.786-8.329 4.922-14.387 1.135-6.057-.379-7.572-1.136-9.086Z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.77 177.081c1.515 1.817 5.301 2.145 6.437 1.893-.63.757-3.786 2.347-5.3 2.65-5.023 1.004-5.3 0-7.194-1.136-1.893-1.136-4.922-5.3-7.572-8.329-2.65-3.029-8.708-8.33-14.009-10.98-4.24-2.12-10.222-4.417-12.872-4.922l5.3-6.436c4.67 1.388 14.009 4.922 19.31 9.086 7.71 6.058 14.008 15.902 15.9 18.174Z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.891 208.126c3.635 2.726 5.553 2.65 6.058 2.272-1.136 1.388-3.862 4.24-5.679 4.543-2.272.379-6.058-1.514-8.708-3.407-2.65-1.893-10.601-9.087-15.144-11.359-3.635-1.817-5.048-1.514-5.301-1.135l1.136-1.893c2.776.126 5.679-.489 11.358 1.135 4.503 1.288 11.737 6.437 16.28 9.844Z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.18 196.011c-4.24-1.514-7.319-1.514-8.329-1.136l-5.679 3.786c.505 0 1.893-.133 4.922.758 6.436 1.893 18.299 10.348 25.745 15.144v-4.543l5.301-.758c-5.553-3.786-17.719-11.736-21.96-13.251Z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.929 201.69c1.212-2.726 1.893-5.679 7.194-7.042-4.165 0-10.601 1.363-12.494 3.256-2.993 2.993-4.543 9.087-6.437 12.115-1.514 2.424-3.786 4.544-6.057 4.922 2.271.379 8.405-1.135 11.737-2.65 4.164-1.893 4.543-7.193 6.057-10.601Z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.594 174.052c1.818-1.212 4.291-1.262 5.301-1.136-2.145-1.136-6.89-3.408-8.708-3.408-2.272 0-7.194 3.408-11.358 7.194-3.332 3.029-7.446 4.796-9.087 5.3 3.534.505 11.283 1.212 14.009 0 3.407-1.514 7.572-6.436 9.843-7.95Z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.603 200.175c2.272-1.893 7.573-2.65 10.98-2.65-4.165-.757-9.844-1.893-13.63-1.136-5.25 1.05-9.086 4.544-11.358 5.68-1.817.908-2.65 1.135-3.407 1.135l2.16 2.469c.323.37.71.689 1.18.839 3.052.972 7.5-.691 9.154-1.793 2.271-1.515 2.65-2.651 4.921-4.544Z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.99 118.236-2.504 3.259v-.283L75.99 118v.236Z",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.184 125.038-2.55 3.164c0-.047-.046-.378-.228-.897-.136-.52-.455-1.228-.91-1.937-.501-.708-1.184-1.511-2.14-2.172-.956-.709-2.231-1.323-3.87-1.701l2.504-3.259c1.639.425 2.914 1.039 3.915 1.748a9.538 9.538 0 0 1 2.14 2.173c.501.755.774 1.417.956 1.936.137.52.183.897.183.945Z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.502 125.085-2.595 3.164-.273-.047 2.55-3.165.318.048Z",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.183 125.038c0-.048-.045-.425-.182-.945a8.48 8.48 0 0 0-.956-1.936 9.542 9.542 0 0 0-2.14-2.173c-1.002-.708-2.277-1.322-3.916-1.748V118c1.73.425 3.05 1.087 4.053 1.795 1.001.756 1.73 1.559 2.23 2.362.547.755.82 1.511 1.002 2.031.182.519.228.85.228.897l-.319-.047Z",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.605 71.978-2.634-2.768.203-.21 2.668 2.768-.237.21Z",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.579 70.051c.157.28.27.549.338.806.067.257.1.514.1.77 0 .258-.033.503-.1.737 0 .023-.012.034-.034.034V72.47c-.203.49-.507.91-.946 1.331-.405.42-.946.84-1.553 1.226-.609.386-1.284.736-1.993 1.086-.71.386-1.453.736-2.196 1.087-.776.35-1.553.735-2.296 1.12-.71.351-1.419.736-2.027 1.122-.608.42-1.114.806-1.553 1.261-.406.42-.71.876-.879 1.366l-.033.07a2.637 2.637 0 0 0-.102.736c0 .234.045.48.135.736.068.234.18.479.338.736.158.257.35.525.574.806l2.5 2.908a5.691 5.691 0 0 1-.575-.771 2.876 2.876 0 0 1-.337-.771 2.225 2.225 0 0 1-.135-.736c0-.257.045-.502.135-.736v-.07c.169-.49.473-.946.912-1.401.405-.42.945-.84 1.553-1.261.642-.386 1.317-.771 2.06-1.156.744-.386 1.52-.736 2.297-1.122.743-.35 1.486-.7 2.23-1.086.709-.35 1.384-.736 1.992-1.12a10.243 10.243 0 0 0 1.588-1.227c.439-.42.743-.876.945-1.331V75.2c0-.023.011-.035.034-.035.068-.233.101-.478.101-.735s-.033-.514-.101-.771c-.067-.28-.18-.56-.338-.841a7.837 7.837 0 0 0-.608-.84l-2.634-2.769c.248.28.45.56.608.841Z",
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.941 84.977c.169-.49.473-.946.912-1.402.405-.42.946-.84 1.554-1.261.641-.385 1.317-.77 2.06-1.156.743-.386 1.52-.736 2.296-1.121.744-.35 1.487-.701 2.23-1.087.709-.35 1.385-.735 1.992-1.12a10.238 10.238 0 0 0 1.588-1.227c.439-.42.743-.876.946-1.331v-.07c0-.024.01-.035.033-.035.068-.234.102-.48.102-.736 0-.257-.034-.514-.102-.771-.067-.28-.18-.56-.338-.84a7.825 7.825 0 0 0-.607-.842l.236-.21c.248.304.45.607.608.911.158.304.281.596.372.876.067.28.1.56.1.84 0 .258-.044.526-.134.807l-.034.035v.07c-.203.49-.54.98-.98 1.436-.472.42-1.013.841-1.654 1.261-.608.386-1.318.806-2.027 1.157-.743.385-1.52.735-2.263 1.12-.743.351-1.486.701-2.195 1.052-.71.385-1.385.736-1.993 1.156-.608.385-1.148.77-1.587 1.191-.406.42-.71.876-.879 1.332-.09.303-.112.619-.067.946.045.327.146.654.304.98.18.351.428.69.743 1.017.315.35.698.712 1.148 1.086l-.202.21a9.59 9.59 0 0 1-1.182-1.086 5.878 5.878 0 0 1-.744-1.086c-.18-.35-.292-.701-.337-1.051a2.096 2.096 0 0 1 .101-.981v-.07Z",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.387 41.189 3.506 7.037-.228.33-3.551-7.037.273-.33Z",
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.115 41.52 3.551 7.037c-.045 0-.273-.048-.683-.095a17.135 17.135 0 0 0-1.821-.094 26.223 26.223 0 0 0-2.732 0c-1.002.047-2.14.189-3.37.33-.85.126-1.745.3-2.686.52-.94.189-1.882.456-2.823.803-.971.315-1.958.692-2.96 1.133-.97.441-1.957.96-2.959 1.559l-3.597-6.943a24.332 24.332 0 0 1 2.96-1.559 25.097 25.097 0 0 1 2.96-1.18 35.755 35.755 0 0 1 2.868-.803c.91-.22 1.806-.394 2.686-.52a31.71 31.71 0 0 1 3.415-.33c1.002-.048 1.912-.048 2.686-.048.774.047 1.412.047 1.822.095.455.047.683.094.683.094Z",
    fill: "url(#P)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.034 45.77-.182-.236a40.687 40.687 0 0 1 3.05-1.606 27.96 27.96 0 0 1 3.006-1.18 28.079 28.079 0 0 1 2.96-.85c.94-.19 1.85-.363 2.731-.52a33.694 33.694 0 0 1 3.46-.331C53.108 41 54.064 41 54.838 41c.774.047 1.411.047 1.821.094.456.047.683.095.729.095l-.273.33s-.228-.047-.683-.094c-.41-.047-1.048-.047-1.822-.095-.774 0-1.684 0-2.686.047a31.741 31.741 0 0 0-3.415.331c-.88.126-1.776.3-2.686.52-.941.22-1.897.488-2.869.803-.971.315-1.958.708-2.96 1.18a24.34 24.34 0 0 0-2.959 1.559Z",
    fill: "url(#Q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.573 104.223-3.506-7.037-.273-.662c-.06-.22-.121-.456-.182-.708a6.598 6.598 0 0 1-.182-1.511c0-.725.106-1.48.319-2.267.182-.756.47-1.528.865-2.315.394-.818.88-1.621 1.457-2.409A16.799 16.799 0 0 1 26.029 85l3.551 7.038a34.513 34.513 0 0 0-2.003 2.361 16.58 16.58 0 0 0-1.457 2.362 10.597 10.597 0 0 0-.865 2.361 8.18 8.18 0 0 0-.32 2.22c0 .283.016.551.046.803s.061.488.091.708c.061.252.137.488.228.709.06.22.152.441.273.661Z",
    fill: "url(#R)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.254 132.722-3.506-6.99c.182.346.395.677.637.992.274.314.562.598.866.85.303.283.652.519 1.047.708.364.221.774.425 1.23.614.485.158.986.284 1.502.378a8.918 8.918 0 0 0 1.639.236c.576.032 1.153.032 1.73 0 .607 0 1.23-.047 1.867-.142l.91-.188.91-.189c.305-.063.623-.142.957-.237l.91-.283a29.75 29.75 0 0 0 2.915-1.181 33.776 33.776 0 0 0 2.777-1.464c.88-.535 1.73-1.133 2.55-1.795A27.711 27.711 0 0 0 31.47 122l3.597 6.896a24.303 24.303 0 0 1-2.322 2.031c-.82.661-1.67 1.26-2.55 1.795-.91.567-1.836 1.07-2.777 1.511a23.4 23.4 0 0 1-2.914 1.134c-.334.126-.652.236-.956.33a8.44 8.44 0 0 1-.956.237l-.91.188-.911.189c-.638.095-1.26.158-1.867.189-.607.032-1.184.032-1.73 0a8.918 8.918 0 0 1-1.64-.236 9.496 9.496 0 0 1-1.502-.378 7.903 7.903 0 0 1-1.275-.566 12.505 12.505 0 0 1-1.047-.709 10.62 10.62 0 0 1-.82-.85 5.863 5.863 0 0 1-.637-1.039Z",
    fill: "url(#S)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.454 183.692-1.913-3.646.178-.046 1.957 3.646-.222.046Z",
    fill: "url(#T)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.196 196.152-1.78-3.646c.222-.969.578-1.753 1.023-2.399a7.037 7.037 0 0 1 1.557-1.708c.579-.508 1.202-.877 1.824-1.246.668-.369 1.335-.692 2.002-1.015.623-.277 1.291-.6 1.913-.923.623-.37 1.246-.739 1.824-1.2a9.5 9.5 0 0 0 1.647-1.662c.489-.646.934-1.384 1.334-2.307l1.913 3.646c-.4.877-.845 1.661-1.334 2.307-.534.646-1.068 1.2-1.647 1.662-.622.461-1.245.83-1.868 1.199-.623.324-1.29.647-1.913.97-.667.277-1.335.6-2.002.969a13.35 13.35 0 0 0-1.869 1.246c-.578.507-1.112 1.061-1.557 1.707a9.014 9.014 0 0 0-1.067 2.4Z",
    fill: "url(#U)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.453 183.692.222-.046a11.83 11.83 0 0 1-1.379 2.4 14.92 14.92 0 0 1-1.69 1.707c-.623.462-1.246.831-1.913 1.2-.668.369-1.335.692-1.958 1.016-.712.323-1.379.599-2.002.969-.623.369-1.246.738-1.779 1.2-.579.461-1.068 1.015-1.513 1.661a9.902 9.902 0 0 0-1.023 2.307l-.223.047a9 9 0 0 1 1.068-2.4c.445-.646.979-1.2 1.557-1.708a13.38 13.38 0 0 1 1.869-1.246 19.82 19.82 0 0 1 2.002-.969c.623-.323 1.29-.646 1.913-.969.623-.369 1.245-.738 1.868-1.2.579-.461 1.112-1.015 1.646-1.661.49-.646.935-1.431 1.335-2.308Z",
    fill: "url(#V)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.641 64.136 2.313-8.768v.692l-2.313 8.814v-.738Z",
    fill: "url(#W)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.012 45.722 2.358-8.584c.044.139.044 1.062.222 2.446.134 1.385.4 3.277.845 5.215.445 1.984 1.068 4.061 1.958 5.907.89 1.892 2.046 3.554 3.559 4.661l-2.313 8.769c-1.513-1.108-2.67-2.815-3.56-4.707-.934-1.846-1.557-3.97-2.002-5.954a43.097 43.097 0 0 1-.845-5.26c-.178-1.385-.222-2.355-.222-2.493Z",
    fill: "url(#X)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.744 45.63 2.403-8.63.222.139-2.358 8.583-.267-.092Z",
    fill: "url(#Y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.011 45.722c0 .139.045 1.108.223 2.492.133 1.43.4 3.277.845 5.261.445 1.985 1.068 4.108 2.002 5.954.89 1.892 2.046 3.6 3.559 4.707v.738c-1.557-1.2-2.803-2.953-3.737-4.984-.934-1.984-1.602-4.246-2.047-6.322-.445-2.123-.756-4.061-.889-5.538-.178-1.431-.178-2.354-.223-2.4l.267.092Z",
    fill: "url(#Z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.915 137.26-4.894-9.737-.044-.37 4.893 9.692.045.415Z",
    fill: "url(#aa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.87 136.844-4.893-9.691c1.646-.692 2.936-1.431 3.915-2.215a10.853 10.853 0 0 0 2.269-2.215 8.085 8.085 0 0 0 1.023-1.754c.222-.462.267-.785.267-.831l4.982 9.692c0 .046-.044.323-.267.784-.177.462-.489 1.062-1.023 1.8-.534.692-1.29 1.431-2.313 2.215-1.023.785-2.314 1.523-3.96 2.215Z",
    fill: "url(#ab)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.434 129.83-4.983-9.692.579-.138 5.027 9.691-.623.139Z",
    fill: "url(#ac)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.057 129.691s-.089.323-.311.785c-.178.508-.534 1.154-1.113 1.938a14.147 14.147 0 0 1-2.446 2.446c-1.068.831-2.492 1.662-4.271 2.4l-.045-.415c1.646-.693 2.936-1.431 3.96-2.216 1.023-.784 1.779-1.523 2.313-2.215.534-.738.845-1.338 1.023-1.8.223-.461.267-.738.267-.784l.623-.139Z",
    fill: "url(#ad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.018 79.69 5.516-2.907.045.323-5.561 2.907v-.323Z",
    fill: "url(#ae)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.045 57.723 251.606 55a11.944 11.944 0 0 1 3.559 1.846c.979.738 1.78 1.615 2.492 2.538.667.97 1.245 1.985 1.735 3.046a70.183 70.183 0 0 1 1.379 3.23c.4 1.062.845 2.077 1.29 3.139.489 1.015 1.023 2.03 1.69 3 .668.969 1.424 1.892 2.358 2.722.979.831 2.091 1.57 3.426 2.262l-5.517 2.907c-1.334-.692-2.491-1.43-3.425-2.307-.934-.831-1.691-1.754-2.358-2.723-.667-.97-1.201-1.985-1.691-3.046a60.677 60.677 0 0 1-1.334-3.138c-.445-1.108-.89-2.216-1.38-3.277-.533-1.061-1.067-2.077-1.779-3.046a12.243 12.243 0 0 0-2.491-2.584 12.246 12.246 0 0 0-3.515-1.846Z",
    fill: "url(#af)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.018 79.69v.323c-1.379-.692-2.535-1.476-3.47-2.353-.978-.83-1.779-1.8-2.447-2.815a21.038 21.038 0 0 1-1.735-3.092c-.489-1.062-.934-2.17-1.379-3.23-.445-1.108-.89-2.216-1.379-3.231-.489-1.062-1.023-2.03-1.691-2.954a12.524 12.524 0 0 0-2.402-2.492c-.934-.692-2.046-1.338-3.426-1.754l-.044-.369a12.246 12.246 0 0 1 3.515 1.846 12.243 12.243 0 0 1 2.491 2.584c.712.97 1.246 1.985 1.779 3.046.49 1.062.935 2.17 1.38 3.277.4 1.015.845 2.077 1.334 3.138.49 1.062 1.024 2.077 1.691 3.046.667.97 1.424 1.892 2.358 2.723.934.877 2.091 1.615 3.425 2.307Z",
    fill: "url(#ag)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.169 41.03-7.386-.416c.178-1.292.223-2.353.134-3.276a8.558 8.558 0 0 0-.489-2.215c-.223-.554-.445-1.016-.623-1.293-.223-.276-.356-.415-.401-.415l7.43.37s.178.184.356.46c.178.278.445.693.623 1.293.222.554.4 1.292.489 2.215.089.923.045 1.985-.133 3.277Z",
    fill: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.834 33.785-7.43-.37.134-.415 7.429.37-.133.415Z",
    fill: "url(#ai)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.967 33.37s.134.138.356.46c.178.278.445.739.712 1.385.223.6.401 1.43.49 2.4.133.97.089 2.169-.134 3.507l-.222-.092c.178-1.292.222-2.354.133-3.277s-.267-1.661-.489-2.215c-.178-.6-.445-1.015-.623-1.292-.178-.277-.356-.462-.356-.462l.133-.415Z",
    fill: "url(#aj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.39 30.088-.284 4.384c.024-.27.012-.54-.035-.81a1.905 1.905 0 0 0-.213-.737 2.42 2.42 0 0 0-.426-.7 2.35 2.35 0 0 0-.675-.59l-.142-.073a.42.42 0 0 0-.106-.074l-.143-.073-.142-.074a9.85 9.85 0 0 0-1.562-.516 14.08 14.08 0 0 0-2.059-.331c-.758-.074-1.61-.11-2.557-.11a33.74 33.74 0 0 0-3.089.073l.213-4.383a72.834 72.834 0 0 1 3.125-.074c.947.025 1.799.074 2.556.147.781.074 1.48.172 2.095.295a7.845 7.845 0 0 1 1.563.552.31.31 0 0 1 .142.037l.142.074c.047.024.082.05.106.074a.56.56 0 0 0 .142.11c.284.172.521.356.71.553.166.22.308.454.426.7.095.22.166.466.213.736.024.27.024.54 0 .81Z",
    fill: "url(#ak)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.64 30.125-.285 4.383c-.023.27-.059.54-.106.81a6.27 6.27 0 0 1-.213.848c-.071.27-.166.552-.284.847-.095.294-.19.577-.284.847l-.284.884a7.06 7.06 0 0 0-.284.847c-.071.295-.142.577-.213.847-.048.27-.083.528-.107.774l.284-4.457c.024-.246.071-.503.142-.774.048-.27.107-.54.178-.81.094-.27.189-.552.284-.847.094-.295.189-.577.284-.847.118-.295.225-.59.319-.884.095-.27.19-.553.284-.847a8.76 8.76 0 0 0 .178-.848c.071-.27.107-.527.107-.773Z",
    fill: "url(#al)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.364 48.652-.533 4.457c.024-.27.036-.552.036-.847.023-.27.023-.552 0-.847-.024-.27-.06-.553-.107-.847a5.047 5.047 0 0 0-.213-.81 9.482 9.482 0 0 0-.426-1.18c-.213-.404-.426-.81-.746-1.215a6.968 6.968 0 0 0-1.136-1.178 8.604 8.604 0 0 0-1.598-.995c-.047 0-.083-.012-.106-.037-.024 0-.048-.012-.071-.036-.024 0-.048-.013-.071-.037-.024 0-.048-.013-.071-.037a15.047 15.047 0 0 0-3.516-1.032c-1.136-.22-2.237-.257-3.337-.22a30.985 30.985 0 0 0-3.231.294 80.325 80.325 0 0 0-3.161.626c-.923.184-1.81.369-2.698.48-.888.146-1.776.257-2.663.294-.852.037-1.705.037-2.557-.11a9.121 9.121 0 0 1-2.45-.811.797.797 0 0 1-.284-.147l-.284-.148a4.888 4.888 0 0 0-.319-.184 1.91 1.91 0 0 0-.284-.184 4.787 4.787 0 0 1-.604-.59 2.493 2.493 0 0 1-.391-.626 3.397 3.397 0 0 1-.213-.736 3.94 3.94 0 0 1 0-.737l.284-4.457c-.023.27-.012.528.036.774.023.245.083.479.177.7.095.22.225.43.391.626s.379.38.639.552l.284.221c.095.05.19.11.284.184.095.05.201.099.32.148l.284.147a7.786 7.786 0 0 0 2.485.774c.853.147 1.705.184 2.557.147a21.787 21.787 0 0 0 2.663-.295c.923-.11 1.811-.294 2.734-.478 1.065-.222 2.13-.443 3.196-.59a23.423 23.423 0 0 1 3.231-.331 17.483 17.483 0 0 1 3.373.22 17.55 17.55 0 0 1 3.551 1.069c.023 0 .047.012.071.037.023 0 .047.012.071.037.023 0 .047.012.071.036.023 0 .047.013.071.037a7.844 7.844 0 0 1 1.633.995c.462.368.852.736 1.136 1.142.32.405.569.81.782 1.215.177.405.319.81.426 1.179.094.27.165.54.213.81.047.27.083.553.106.847.024.27.024.553 0 .847 0 .27-.012.553-.035.847Z",
    fill: "url(#am)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.884 54.988-.497 4.53-.213-.147.497-4.53.213.147Z",
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.612 48.689-.533 4.494a8.632 8.632 0 0 1-.426 1.841 8.635 8.635 0 0 1-.745 1.731 9.995 9.995 0 0 1-1.136 1.51 7.712 7.712 0 0 1-1.385 1.253l.497-4.53a8.78 8.78 0 0 0 1.42-1.253 7.976 7.976 0 0 0 1.136-1.51 8.9 8.9 0 0 0 .746-1.694 8.635 8.635 0 0 0 .426-1.842Z",
    fill: "url(#ao)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 274.017,
    y1: 157.762,
    x2: 299.564,
    y2: 173.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#E7B83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3852A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 230.413,
    y1: 205.973,
    x2: 277.017,
    y2: 173.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#EABB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986A20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 302.898,
    y1: 154.545,
    x2: 328.302,
    y2: 135.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#E9BA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F611D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 317.915,
    y1: 118.906,
    x2: 347.72,
    y2: 95.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F611D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#E9B93D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91631D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 315.118,
    y1: 114.797,
    x2: 332.959,
    y2: 136.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7943D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#E5D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6923B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 269.94,
    y1: 154.677,
    x2: 279.197,
    y2: 179.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#E2CF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C59039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 302.193,
    y1: 151.038,
    x2: 301.993,
    y2: 174.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 260.13,
    y1: 165.474,
    x2: 193.879,
    y2: 198.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0A84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#E4D580"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 227.82,
    y1: 150.72,
    x2: 227.82,
    y2: 166.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93601B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE8E3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 111.85,
    y1: 189.4,
    x2: 198.351,
    y2: 194.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#D6B64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAB256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 156.441,
    y1: 153.52,
    x2: 156.441,
    y2: 167.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93601B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE8E3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 152.785,
    y1: 150.16,
    x2: 152.785,
    y2: 232.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 106.56,
    y1: 136.04,
    x2: 202.454,
    y2: 149.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#C7A74C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCC765"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 233.84,
    y1: 136.72,
    x2: 233.84,
    y2: 231.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 267.381,
    y1: 126.92,
    x2: 197.819,
    y2: 146.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFA74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E188"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 167.917,
    y1: 86.994,
    x2: 190.957,
    y2: 141.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6DD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3DFBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 128.315,
    y1: 59.48,
    x2: 186.43,
    y2: 108.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 246.053,
    y1: 59.48,
    x2: 187.937,
    y2: 108.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 218.737,
    y1: 84.189,
    x2: 207.725,
    y2: 126.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 153.276,
    y1: 90.497,
    x2: 182.869,
    y2: 125.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 187.883,
    y1: 108.488,
    x2: 187.883,
    y2: 125.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 89.534,
    y1: 172.159,
    x2: 86.458,
    y2: 203.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#E7B83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3852A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 23.61,
    y1: 152.471,
    x2: 75.479,
    y2: 182.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#EABB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986A20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 105.767,
    y1: 198.282,
    x2: 135.677,
    y2: 213.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#E9BA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F611D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 146.657,
    y1: 196.39,
    x2: 182.625,
    y2: 214.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F611D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#E9B93D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91631D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 149.308,
    y1: 191.846,
    x2: 136.814,
    y2: 218.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7943D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#E5D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6923B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 90.623,
    y1: 166.858,
    x2: 71.314,
    y2: 186.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#E2CF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C59039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 108.797,
    y1: 196.011,
    x2: 86.081,
    y2: 206.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 73.82,
    y1: 121.537,
    x2: 76.222,
    y2: 121.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 74.779,
    y1: 128.323,
    x2: 83.96,
    y2: 126.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 81.016,
    y1: 128.288,
    x2: 83.744,
    y2: 127.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 76.991,
    y1: 125.171,
    x2: 84.066,
    y2: 123.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 91.354,
    y1: 72.014,
    x2: 94.073,
    y2: 71.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 80.485,
    y1: 88.287,
    x2: 96.051,
    y2: 85.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 82.701,
    y1: 89.462,
    x2: 96.171,
    y2: 87.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 57.617,
    y1: 48.646,
    x2: 61.27,
    y2: 48.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 40.186,
    y1: 52.85,
    x2: 60.516,
    y2: 45.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 39.59,
    y1: 45.828,
    x2: 52.338,
    y2: 36.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 22.517,
    y1: 104.455,
    x2: 30.413,
    y2: 103.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 10.524,
    y1: 136.699,
    x2: 35.228,
    y2: 128.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 331.392,
    y1: 179.955,
    x2: 329.332,
    y2: 180.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 329.448,
    y1: 179.851,
    x2: 315.181,
    y2: 182.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 329.878,
    y1: 183.495,
    x2: 317.198,
    y2: 185.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 182.646,
    y1: 55.253,
    x2: 180.396,
    y2: 55.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 181.762,
    y1: 36.812,
    x2: 173.079,
    y2: 37.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 176.019,
    y1: 36.895,
    x2: 173.469,
    y2: 37.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 179.72,
    y1: 45.397,
    x2: 173.029,
    y2: 45.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 359.256,
    y1: 127.031,
    x2: 354.48,
    y2: 127.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 365.773,
    y1: 119.936,
    x2: 353.841,
    y2: 121.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 367.309,
    y1: 119.881,
    x2: 361.902,
    y2: 120.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 366.966,
    y1: 129.6,
    x2: 359.267,
    y2: 131.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 268.837,
    y1: 76.744,
    x2: 263.872,
    y2: 78.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 266.403,
    y1: 54.702,
    x2: 244.138,
    y2: 58.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 261.622,
    y1: 57.454,
    x2: 244.455,
    y2: 59.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 244.154,
    y1: 33.323,
    x2: 235.797,
    y2: 35.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 242.959,
    y1: 32.99,
    x2: 241.048,
    y2: 36.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 245.364,
    y1: 33.276,
    x2: 243.647,
    y2: 33.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 311.881,
    y1: 25.898,
    x2: 301.318,
    y2: 28.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 313.365,
    y1: 29.991,
    x2: 311.361,
    y2: 30.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 338.27,
    y1: 36.558,
    x2: 310.998,
    y2: 45.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 338.789,
    y1: 54.784,
    x2: 338.098,
    y2: 54.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 342.049,
    y1: 48.558,
    x2: 337.951,
    y2: 48.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4D580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7953D"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 110,
    y: 121.459,
    width: 93.311,
    height: 40.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_15124_22202"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 203.311,
    y: 114.846,
    width: 61.49,
    height: 46.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_15124_22202"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: 111.721,
    y: 106,
    width: 150.18,
    height: 29.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_15124_22202"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "y",
    x: 179.439,
    y: 108.488,
    width: 16.887,
    height: 17.232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_15124_22202"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h375v240H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftVoucher);
export default __webpack_public_path__ + "static/media/gift-voucher.c531127c040f6099f9d4cff7b8688b4a.svg";
export { ForwardRef as ReactComponent };